/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum HolidayCalendar {
  ISR = 'isr',
  ILS = 'ils',
  US = 'us',
}
